module.exports = __webpack_public_path__ + "img/talvipiha_2.8cde5ba9.jpeg";